import {
  WellAttributesDocument,
  WellAttributesSummariesDocument,
  type WellAttribute,
} from "$/__generated__/graphql";
import { OverviewDataTables } from "components/tables";
import {
  WELL_ATTRIBUTES_BASE_DEFS,
  WELL_ATTRIBUTES_ROUNDING,
} from "constants/column-defs";
import { useGlobalFiltersContext } from "contexts/filters";
import {
  useDataTable,
  useDataTableSummaries,
  useSummariesFormatters,
} from "hooks/queries";
import { useAppliedColumns } from "hooks/useAppliedColumns";

export const SystemOverviewWellAttributes = () => {
  const { hierarchyIds } = useGlobalFiltersContext();

  const {
    showFoot,
    systemMetric,
    selectionMetric,
    setSelectionMetric,
    setSystemMetric,
    setShowFoot,
    rows,
    loading,
    fetchMoreDataTable,
    isFetchingMore,
  } = useDataTable<WellAttribute>("wellAttributes", WellAttributesDocument, {
    variables: {
      hierarchyIds,
    },
  });

  const appliedColumns = useAppliedColumns<WellAttribute>(
    "WellAttributes",
    WELL_ATTRIBUTES_BASE_DEFS,
  );

  const { columns } = useDataTableSummaries(
    appliedColumns,
    WellAttributesSummariesDocument,
    {
      variables: {
        hierarchyIds,
        selectionMetricType: selectionMetric,
        systemMetricType: systemMetric,
      },
    },
    useSummariesFormatters(
      selectionMetric,
      systemMetric,
      WELL_ATTRIBUTES_ROUNDING,
    ),
  );

  return (
    <OverviewDataTables
      loading={loading}
      data={rows}
      columns={columns}
      selectionValue={selectionMetric}
      systemValue={systemMetric}
      showFoot={showFoot}
      onSelectionChange={setSelectionMetric}
      onSystemChange={setSystemMetric}
      setShowFoot={setShowFoot}
      onFetchMore={fetchMoreDataTable}
      isFetchingMore={isFetchingMore}
    />
  );
};

export default SystemOverviewWellAttributes;
